import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        questiontype:[],
        classmap:new Map(),
        username:null,
        headlist:[],
        qplist:[],
		token:''
    },
    mutations: {
        setquestiontype(state,value) {
            state.questiontype = value
        },
        setclassmap(state,value) {
            state.classmap = value
        },
        setusername(state,value){
            state.username = value
        },
        setheadlist(state,value){
            state.headlist = value
        },
        setqplist(state,value){
            state.qplist = value
        },
		setToken(state,value){
		    state.token = value
		},
		//登出
		LOGOOUT:(state)=>{
			state.token = null
		}
    },
    actions: {

    },
	 plugins: [createPersistedState({
		 storage: window.sessionStorage
	    // reducer(val) {
	    //   return {
	    //     token: val.token,
	    //     roles: val.roles,
	    //     tagsList: val.tagsList,
	    //     lang:val.lang,
	    //     breadList:val.breadList
	    //   }
	    // }
	  })]
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js